import { VehicleTsSearchTable } from "../component/vehicleTsSearchCSV/VehicleTsSearchTable";

export const VehicleTsSearchPage = () => {
  return (
    <>
      <VehicleTsSearchTable />
    </>
  );
};
